module.exports = __webpack_public_path__ + "img/blob4.3dd753b3.svg";